"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get addOrRemoveLinks () {
        return addOrRemoveLinks;
    },
    get extractCorrespondingLinkColumn () {
        return extractCorrespondingLinkColumn;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _catchError = require("~/helpers/catchError");
const _dbHelpers = require("~/helpers/dbHelpers");
const _models = require("~/models");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const extractCorrespondingLinkColumn = async (context, param)=>{
    const { ltarColumn } = param;
    if (!(0, _nocodbsdk.isLinksOrLTAR)(ltarColumn)) {
        return null;
    }
    const colOptions = await ltarColumn.getColOptions(_extends({}, context, {
        base_id: ltarColumn.base_id
    }));
    const { refContext } = colOptions.getRelContext(context);
    // Get the table that contains the LTAR column
    const sourceTableId = ltarColumn.fk_model_id;
    // Get columns from the referenced table or use provided columns
    let columnsInReferencedTable;
    if (param.referencedTableColumns) {
        columnsInReferencedTable = param.referencedTableColumns;
    } else if (param.referencedTable) {
        columnsInReferencedTable = param.referencedTable.columns || await param.referencedTable.getColumns(refContext);
    } else {
        // Extract referenced table columns from ref table ID if not provided
        const refTableId = colOptions.fk_related_model_id;
        const refTable = await _models.Model.get(context, refTableId);
        columnsInReferencedTable = refTable.columns || await refTable.getColumns(refContext);
    }
    // Find the corresponding link column based on the relation type
    for (const column of columnsInReferencedTable){
        if (!(0, _nocodbsdk.isLinksOrLTAR)(column)) continue;
        const passContext = column.base_id === refContext.base_id ? refContext : context;
        const refColOptions = await column.getColOptions(passContext);
        // Check if this column links back to the source table
        if (refColOptions.fk_related_model_id !== sourceTableId) continue;
        // Handle different relation types
        switch(colOptions.type){
            case _nocodbsdk.RelationTypes.HAS_MANY:
                // For HM, the referenced table should have a BT column and parent child will remain same
                if (refColOptions.type === _nocodbsdk.RelationTypes.BELONGS_TO && refColOptions.fk_child_column_id === colOptions.fk_child_column_id && refColOptions.fk_parent_column_id === colOptions.fk_parent_column_id) {
                    return column;
                }
                break;
            case _nocodbsdk.RelationTypes.BELONGS_TO:
                // For BT, the referenced table should have an HM column, and parent child will remain same
                if (refColOptions.type === _nocodbsdk.RelationTypes.HAS_MANY && refColOptions.fk_child_column_id === colOptions.fk_child_column_id && refColOptions.fk_parent_column_id === colOptions.fk_parent_column_id) {
                    return column;
                }
                break;
            case _nocodbsdk.RelationTypes.ONE_TO_ONE:
                // For OO, the referenced table should have an OO column and parent child will remain same
                if (refColOptions.type === _nocodbsdk.RelationTypes.ONE_TO_ONE && refColOptions.fk_child_column_id === colOptions.fk_child_column_id && refColOptions.fk_parent_column_id === colOptions.fk_parent_column_id) {
                    return column;
                }
                break;
            case _nocodbsdk.RelationTypes.MANY_TO_MANY:
                // For MM, check if the referenced table has an MM column that references the same junction table
                // and the parent-child columns are swapped
                if (refColOptions.type === _nocodbsdk.RelationTypes.MANY_TO_MANY && refColOptions.fk_mm_model_id === colOptions.fk_mm_model_id && // Same junction table
                refColOptions.fk_related_model_id === sourceTableId) {
                    // Additional check for MM columns to ensure they're properly linked
                    // The junction table ID (fk_mm_model_id) is already verified above
                    if (refColOptions.fk_mm_parent_column_id === colOptions.fk_mm_child_column_id && refColOptions.fk_mm_child_column_id === colOptions.fk_mm_parent_column_id) {
                        return column;
                    }
                }
                break;
        }
    }
    return null;
};
const addOrRemoveLinks = (baseModel)=>{
    const validateRefIds = (refIds, refModel)=>{
        for (const refId of Array.isArray(refIds) ? refIds : [
            refIds
        ]){
            if (typeof refId === 'object') {
                for (const primaryKey of refModel.primaryKeys){
                    if ((0, _nocodbsdk.ncIsNullOrUndefined)((0, _dbHelpers.dataWrapper)(refId).getByColumnNameTitleOrId(primaryKey))) {
                        _catchError.NcError.get(baseModel.context).unprocessableEntity(`Validation failed: Missing primary key column "${primaryKey.title}" in request for model "${refModel.title}". RefId: ${JSON.stringify(refId)}`);
                    }
                }
            } else if ((0, _nocodbsdk.ncIsNullOrUndefined)(refId)) {
                _catchError.NcError.get(baseModel.context).unprocessableEntity(`Validation failed: Invalid id "${JSON.stringify(refId)}" for model "${refModel.title}".`);
            }
        }
    };
    const addLinks = async ({ cookie, childIds: _childIds, colId, rowId })=>{
        await baseModel.model.getColumns(baseModel.context);
        const column = baseModel.model.columnsById[colId];
        if (!column || !(0, _nocodbsdk.isLinksOrLTAR)(column)) _catchError.NcError.get(baseModel.context).fieldNotFound(colId);
        const row = await baseModel.readByPk(rowId, false, {}, {
            ignoreView: true,
            getHiddenColumn: true
        });
        // validate rowId
        if (!row) {
            _catchError.NcError.get(baseModel.context).recordNotFound(rowId);
        }
        if (!_childIds.length) return;
        const colOptions = await column.getColOptions(baseModel.context);
        const { childContext, parentContext, mmContext } = await colOptions.getParentChildContext(baseModel.context);
        const childColumn = await colOptions.getChildColumn(childContext);
        const parentColumn = await colOptions.getParentColumn(parentContext);
        const parentTable = await parentColumn.getModel(parentContext);
        const childTable = await childColumn.getModel(childContext);
        await childTable.getColumns(childContext);
        await parentTable.getColumns(parentContext);
        const childBaseModel = await _models.Model.getBaseModelSQL(childContext, {
            model: childTable,
            dbDriver: baseModel.dbDriver
        });
        const parentBaseModel = await _models.Model.getBaseModelSQL(parentContext, {
            model: parentTable,
            dbDriver: baseModel.dbDriver
        });
        const childTn = childBaseModel.getTnPath(childTable);
        const parentTn = parentBaseModel.getTnPath(parentTable);
        let relationType = (0, _nocodbsdk.isMMOrMMLike)(column) ? 'mm' : colOptions.type;
        let childIds = _childIds;
        const relatedChildCol = (0, _dbHelpers.getRelatedLinksColumn)(column, baseModel.model.id === parentTable.id ? childTable : parentTable);
        const auditConfig = {
            childModel: childTable,
            parentModel: parentTable,
            childColTitle: (relatedChildCol == null ? void 0 : relatedChildCol.title) || '',
            parentColTitle: column.title,
            childColId: (relatedChildCol == null ? void 0 : relatedChildCol.id) || '',
            parentColId: column.id
        };
        if (relationType === _nocodbsdk.RelationTypes.ONE_TO_ONE) {
            var _column_meta, _column_meta1, _column_meta2, _column_meta3;
            relationType = ((_column_meta = column.meta) == null ? void 0 : _column_meta.bt) ? _nocodbsdk.RelationTypes.BELONGS_TO : _nocodbsdk.RelationTypes.HAS_MANY;
            childIds = childIds.slice(0, 1);
            validateRefIds(childIds, relationType === _nocodbsdk.RelationTypes.BELONGS_TO ? parentTable : childTable);
            // unlink
            await baseModel.execAndParse(baseModel.dbDriver(childTn).where({
                [childColumn.column_name]: baseModel.dbDriver.from(baseModel.dbDriver(parentTn).select(parentColumn.column_name).where((0, _dbHelpers._wherePk)(parentTable.primaryKeys, ((_column_meta1 = column.meta) == null ? void 0 : _column_meta1.bt) ? childIds[0] : rowId)).first().as('___cn_alias'))
            }).update({
                [childColumn.column_name]: null
            }), null, {
                raw: true
            });
            auditConfig.parentModel = ((_column_meta2 = column.meta) == null ? void 0 : _column_meta2.bt) ? childTable : parentTable;
            auditConfig.childModel = ((_column_meta3 = column.meta) == null ? void 0 : _column_meta3.bt) ? parentTable : childTable;
        }
        switch(relationType){
            case _nocodbsdk.RelationTypes.MANY_TO_MANY:
                {
                    var _this;
                    // V2 mo/oo: child can only link to one parent — truncate to 1
                    if ((0, _nocodbsdk.isLinkV2)(column) && [
                        'mo',
                        'oo'
                    ].includes(colOptions.type)) {
                        childIds = childIds.slice(0, 1);
                    }
                    validateRefIds(childIds, parentTable);
                    const vChildCol = await colOptions.getMMChildColumn(mmContext);
                    const vParentCol = await colOptions.getMMParentColumn(mmContext);
                    const vTable = await colOptions.getMMModel(mmContext);
                    const assocBaseModel = await _models.Model.getBaseModelSQL(mmContext, {
                        model: vTable,
                        dbDriver: baseModel.dbDriver
                    });
                    const refBaseModel = parentBaseModel;
                    const vTn = assocBaseModel.getTnPath(vTable);
                    let insertData;
                    // validate Ids
                    {
                        const childRowsQb = baseModel.dbDriver(parentTn).select(`${parentTn}.${parentColumn.column_name}`).select(`${vTn}.${vChildCol.column_name}`).leftJoin(vTn, (qb)=>{
                            var _row_childColumn_title;
                            qb.on(`${vTn}.${vParentCol.column_name}`, `${parentTn}.${parentColumn.column_name}`).andOn(`${vTn}.${vChildCol.column_name}`, baseModel.dbDriver.raw('?', [
                                (_row_childColumn_title = row[childColumn.title]) != null ? _row_childColumn_title : row[childColumn.column_name]
                            ]));
                        });
                        if (parentTable.primaryKeys.length > 1) {
                            childRowsQb.where((qb)=>{
                                for (const childId of childIds){
                                    qb.orWhere((0, _dbHelpers._wherePk)(parentTable.primaryKeys, childId));
                                }
                            });
                        } else {
                            childRowsQb.whereIn(`${parentTn}.${parentTable.primaryKey.column_name}`, typeof childIds[0] === 'object' ? childIds.map((c)=>(0, _dbHelpers.dataWrapper)(c).getByColumnNameTitleOrId(parentTable.primaryKey)) : childIds);
                        }
                        if (parentTable.primaryKey.column_name !== parentColumn.column_name) childRowsQb.select(`${parentTn}.${parentTable.primaryKey.column_name}`);
                        const childRows = await refBaseModel.execAndParse(childRowsQb, null, {
                            raw: true
                        });
                        if (childRows.length !== childIds.length) {
                            const missingIds = childIds.filter((id)=>!childRows.find((r)=>r[parentColumn.column_name] === id));
                            _catchError.NcError.get(baseModel.context).recordNotFound((0, _dbHelpers.extractIds)(missingIds));
                        }
                        insertData = childRows// skip existing links
                        .filter((childRow)=>!childRow[vChildCol.column_name])// generate insert data for new links
                        .map((childRow)=>({
                                [vParentCol.column_name]: (0, _dbHelpers.dataWrapper)(childRow).getByColumnNameTitleOrId(parentColumn),
                                [vChildCol.column_name]: (0, _dbHelpers.dataWrapper)(row).getByColumnNameTitleOrId(childColumn)
                            }));
                        // if no new links, return true
                        if (!insertData.length) return true;
                    }
                    // V2 cardinality enforcement: remove conflicting junction rows before insert
                    if ((0, _nocodbsdk.isLinkV2)(column) && colOptions.type !== _nocodbsdk.RelationTypes.MANY_TO_MANY) {
                        const unlinkAuditParentObj = [];
                        const unlinkAuditChildObj = [];
                        // mo/oo: child can only link to one parent — clear existing child links
                        if ([
                            'mo',
                            'oo'
                        ].includes(colOptions.type)) {
                            const childFkValue = (0, _dbHelpers.dataWrapper)(row).getByColumnNameTitleOrId(childColumn);
                            const existing = await assocBaseModel.execAndParse(baseModel.dbDriver(vTn).select(vChildCol.column_name, vParentCol.column_name).where(vChildCol.column_name, childFkValue), null, {
                                raw: true
                            });
                            if (existing.length) {
                                await assocBaseModel.execAndParse(baseModel.dbDriver(vTn).where(vChildCol.column_name, childFkValue).delete(), null, {
                                    raw: true
                                });
                                for (const r of existing){
                                    unlinkAuditParentObj.push({
                                        rowId: r[vParentCol.column_name],
                                        refRowId: r[vChildCol.column_name],
                                        type: colOptions.type
                                    });
                                    if (parentTable.id !== childTable.id) {
                                        unlinkAuditChildObj.push({
                                            rowId: r[vChildCol.column_name],
                                            refRowId: r[vParentCol.column_name],
                                            type: (0, _dbHelpers.getOppositeRelationType)(colOptions.type)
                                        });
                                    }
                                }
                            }
                        }
                        // om/oo: each parent can only be linked by one child — clear existing parent links
                        if ([
                            'om',
                            'oo'
                        ].includes(colOptions.type)) {
                            for (const data of insertData){
                                const parentFkValue = data[vParentCol.column_name];
                                const existing = await assocBaseModel.execAndParse(baseModel.dbDriver(vTn).select(vChildCol.column_name, vParentCol.column_name).where(vParentCol.column_name, parentFkValue), null, {
                                    raw: true
                                });
                                if (existing.length) {
                                    await assocBaseModel.execAndParse(baseModel.dbDriver(vTn).where(vParentCol.column_name, parentFkValue).delete(), null, {
                                        raw: true
                                    });
                                    for (const r of existing){
                                        unlinkAuditParentObj.push({
                                            rowId: r[vParentCol.column_name],
                                            refRowId: r[vChildCol.column_name],
                                            type: colOptions.type
                                        });
                                        if (parentTable.id !== childTable.id) {
                                            unlinkAuditChildObj.push({
                                                rowId: r[vChildCol.column_name],
                                                refRowId: r[vParentCol.column_name],
                                                type: (0, _dbHelpers.getOppositeRelationType)(colOptions.type)
                                            });
                                        }
                                    }
                                }
                            }
                        }
                        // Emit unlink audit for cascaded removals
                        if (unlinkAuditParentObj.length) {
                            baseModel.dbDriver.attachToTransaction(async ()=>{
                                const clone = baseModel.getNonTransactionalClone();
                                await clone.afterAddOrRemoveChild({
                                    opType: _nocodbsdk.AuditV1OperationTypes.DATA_UNLINK,
                                    model: auditConfig.parentModel,
                                    refModel: auditConfig.childModel,
                                    columnTitle: auditConfig.parentColTitle,
                                    columnId: auditConfig.parentColId,
                                    refColumnTitle: auditConfig.childColTitle,
                                    refColumnId: auditConfig.childColId,
                                    req: cookie
                                }, unlinkAuditParentObj);
                                if (unlinkAuditChildObj.length) {
                                    await clone.afterAddOrRemoveChild({
                                        opType: _nocodbsdk.AuditV1OperationTypes.DATA_UNLINK,
                                        model: auditConfig.childModel,
                                        refModel: auditConfig.parentModel,
                                        columnTitle: auditConfig.childColTitle,
                                        columnId: auditConfig.childColId,
                                        refColumnTitle: auditConfig.parentColTitle,
                                        refColumnId: auditConfig.parentColId,
                                        req: cookie
                                    }, unlinkAuditChildObj);
                                }
                            });
                        }
                    }
                    // todo: use bulk insert
                    await baseModel.execAndParse(baseModel.dbDriver(vTn).insert(insertData), null, {
                        raw: true
                    });
                    await parentBaseModel.updateLastModified({
                        model: parentTable,
                        rowIds: childIds,
                        cookie,
                        updatedColIds: [
                            (_this = await extractCorrespondingLinkColumn(baseModel.context, {
                                ltarColumn: column,
                                referencedTable: parentTable,
                                referencedTableColumns: parentTable.columns
                            })) == null ? void 0 : _this.id
                        ]
                    });
                    baseModel.dbDriver.attachToTransaction(async ()=>{
                        await parentBaseModel.getNonTransactionalClone().broadcastLinkUpdates(childIds);
                    });
                    await childBaseModel.updateLastModified({
                        model: childTable,
                        updatedColIds: [
                            column.id
                        ],
                        rowIds: [
                            rowId
                        ],
                        cookie
                    });
                    baseModel.dbDriver.attachToTransaction(async ()=>{
                        await childBaseModel.getNonTransactionalClone().broadcastLinkUpdates([
                            rowId
                        ]);
                    });
                    auditConfig.parentModel = baseModel.model.id === parentTable.id ? parentTable : childTable;
                    auditConfig.childModel = baseModel.model.id === parentTable.id ? childTable : parentTable;
                }
                break;
            case _nocodbsdk.RelationTypes.HAS_MANY:
                {
                    validateRefIds(childIds, childTable);
                    // validate Ids
                    {
                        const childRowsQb = baseModel.dbDriver(childTn).select(childTable.primaryKey.column_name);
                        if (childTable.primaryKeys.length > 1) {
                            childRowsQb.where((qb)=>{
                                for (const childId of childIds){
                                    qb.orWhere((0, _dbHelpers._wherePk)(childTable.primaryKeys, childId));
                                }
                            });
                        } else {
                            childRowsQb.whereIn(parentTable.primaryKey.column_name, typeof childIds[0] === 'object' ? childIds.map((c)=>(0, _dbHelpers.dataWrapper)(c).getByColumnNameTitleOrId(parentTable.primaryKey)) : childIds);
                        }
                        const childRows = await childBaseModel.execAndParse(childRowsQb, null, {
                            raw: true
                        });
                        if (childRows.length !== childIds.length) {
                            const missingIds = childIds.filter((id)=>!childRows.find((r)=>r[parentColumn.column_name] === id));
                            _catchError.NcError.get(baseModel.context).recordNotFound((0, _dbHelpers.extractIds)(missingIds));
                        }
                    }
                    const updateQb = baseModel.dbDriver(childTn).update({
                        [childColumn.column_name]: baseModel.dbDriver.from(baseModel.dbDriver(parentTn).select(parentColumn.column_name).where((0, _dbHelpers._wherePk)(parentTable.primaryKeys, rowId)).first().as('___cn_alias'))
                    });
                    if (childTable.primaryKeys.length > 1) {
                        updateQb.where((qb)=>{
                            for (const childId of childIds){
                                qb.orWhere((0, _dbHelpers._wherePk)(childTable.primaryKeys, childId));
                            }
                        });
                    } else {
                        updateQb.whereIn(childTable.primaryKey.column_name, typeof childIds[0] === 'object' ? childIds.map((c)=>(0, _dbHelpers.dataWrapper)(c).getByColumnNameTitleOrId(childTable.primaryKey)) : childIds);
                    }
                    await baseModel.execAndParse(updateQb, null, {
                        raw: true
                    });
                    await parentBaseModel.updateLastModified({
                        model: parentTable,
                        rowIds: [
                            rowId
                        ],
                        cookie,
                        updatedColIds: [
                            column.id
                        ]
                    });
                    baseModel.dbDriver.attachToTransaction(async ()=>{
                        await parentBaseModel.getNonTransactionalClone().broadcastLinkUpdates([
                            rowId
                        ]);
                    });
                }
                break;
            case _nocodbsdk.RelationTypes.BELONGS_TO:
                {
                    validateRefIds(childIds, parentTable);
                    auditConfig.parentModel = childTable;
                    auditConfig.childModel = parentTable;
                    const refBaseModel = parentBaseModel;
                    // validate Ids
                    {
                        const childRowsQb = baseModel.dbDriver(parentTn).select(parentTable.primaryKey.column_name).where((0, _dbHelpers._wherePk)(parentTable.primaryKeys, childIds[0])).first();
                        const childRow = await refBaseModel.execAndParse(childRowsQb, null, {
                            first: true,
                            raw: true
                        });
                        if (!childRow) {
                            _catchError.NcError.get(baseModel.context).recordNotFound((0, _dbHelpers.extractIds)(childIds, true));
                        }
                    }
                    await childBaseModel.execAndParse(baseModel.dbDriver(childTn).update({
                        [childColumn.column_name]: baseModel.dbDriver.from(baseModel.dbDriver(parentTn).select(parentColumn.column_name).where((0, _dbHelpers._wherePk)(parentTable.primaryKeys, childIds[0]))// .whereIn(parentTable.primaryKey.column_name, childIds)
                        .first().as('___cn_alias'))
                    }).where((0, _dbHelpers._wherePk)(childTable.primaryKeys, rowId)), null, {
                        raw: true
                    });
                    await parentBaseModel.updateLastModified({
                        model: parentTable,
                        rowIds: [
                            rowId
                        ],
                        cookie,
                        updatedColIds: [
                            column.id
                        ]
                    });
                    baseModel.dbDriver.attachToTransaction(async ()=>{
                        await parentBaseModel.getNonTransactionalClone().broadcastLinkUpdates([
                            rowId
                        ]);
                    });
                }
                break;
        }
        const parentAuditObj = [];
        const childAuditObj = [];
        for (const childId of childIds){
            var _row_column_title;
            const _childId = typeof childId === 'object' ? childBaseModel.extractPksValues(childId, true) : childId;
            parentAuditObj.push({
                rowId,
                refRowId: _childId,
                displayValue: (_row_column_title = row[column.title]) != null ? _row_column_title : row[column.column_name],
                type: colOptions.type
            });
            if (parentTable.id !== childTable.id) {
                childAuditObj.push({
                    rowId: _childId,
                    refRowId: rowId,
                    refDisplayValue: (0, _dbHelpers.dataWrapper)(row).getByColumnNameTitleOrId(childColumn),
                    type: (0, _dbHelpers.getOppositeRelationType)(colOptions.type)
                });
            }
        }
        baseModel.dbDriver.attachToTransaction(async ()=>{
            const baseModelClone = baseModel.getNonTransactionalClone();
            await baseModelClone.afterAddOrRemoveChild({
                opType: _nocodbsdk.AuditV1OperationTypes.DATA_LINK,
                model: auditConfig.parentModel,
                refModel: auditConfig.childModel,
                columnTitle: auditConfig.parentColTitle,
                columnId: auditConfig.parentColId,
                refColumnTitle: auditConfig.childColTitle,
                refColumnId: auditConfig.childColId,
                req: cookie
            }, parentAuditObj);
            await baseModelClone.afterAddOrRemoveChild({
                opType: _nocodbsdk.AuditV1OperationTypes.DATA_LINK,
                model: auditConfig.childModel,
                refModel: auditConfig.parentModel,
                columnTitle: auditConfig.childColTitle,
                columnId: auditConfig.childColId,
                refColumnTitle: auditConfig.parentColTitle,
                refColumnId: auditConfig.parentColId,
                req: cookie
            }, childAuditObj);
        });
    };
    const removeLinks = async ({ cookie, childIds, colId, rowId })=>{
        await baseModel.model.getColumns(baseModel.context);
        const column = baseModel.model.columnsById[colId];
        if (!column || !(0, _nocodbsdk.isLinksOrLTAR)(column)) _catchError.NcError.get(baseModel.context).fieldNotFound(colId);
        const row = await baseModel.readByPk(rowId, false, {}, {
            ignoreView: true,
            getHiddenColumn: true
        });
        // validate rowId
        if (!row) {
            _catchError.NcError.get(baseModel.context).recordNotFound(rowId);
        }
        if (!childIds.length) return;
        const colOptions = await column.getColOptions(baseModel.context);
        const { parentContext, childContext, mmContext } = await colOptions.getParentChildContext(baseModel.context);
        const childColumn = await colOptions.getChildColumn(childContext);
        const parentColumn = await colOptions.getParentColumn(parentContext);
        const parentTable = await parentColumn.getModel(parentContext);
        const childTable = await childColumn.getModel(childContext);
        await childTable.getColumns(childContext);
        await parentTable.getColumns(parentContext);
        const childBaseModel = await _models.Model.getBaseModelSQL(childContext, {
            model: childTable,
            dbDriver: baseModel.dbDriver
        });
        const parentBaseModel = await _models.Model.getBaseModelSQL(parentContext, {
            model: parentTable,
            dbDriver: baseModel.dbDriver
        });
        const childTn = childBaseModel.getTnPath(childTable);
        const parentTn = parentBaseModel.getTnPath(parentTable);
        const relatedChildCol = (0, _dbHelpers.getRelatedLinksColumn)(column, baseModel.model.id === parentTable.id ? childTable : parentTable);
        const _auditUpdateObj = [];
        const auditConfig = {
            childModel: childTable,
            parentModel: parentTable,
            childColTitle: (relatedChildCol == null ? void 0 : relatedChildCol.title) || '',
            parentColTitle: column.title,
            childColId: (relatedChildCol == null ? void 0 : relatedChildCol.id) || '',
            parentColId: column.id
        };
        const relationType = (0, _nocodbsdk.isMMOrMMLike)(column) ? 'mm' : colOptions.type;
        switch(relationType){
            case _nocodbsdk.RelationTypes.MANY_TO_MANY:
                {
                    var _this;
                    validateRefIds(childIds, parentTable);
                    const vChildCol = await colOptions.getMMChildColumn(mmContext);
                    const vParentCol = await colOptions.getMMParentColumn(mmContext);
                    const vTable = await colOptions.getMMModel(mmContext);
                    const assocBaseModel = await _models.Model.getBaseModelSQL(mmContext, {
                        model: vTable,
                        dbDriver: baseModel.dbDriver
                    });
                    const refBaseModel = parentBaseModel;
                    // validate Ids
                    {
                        const childRowsQb = baseModel.dbDriver(parentTn).select(parentColumn.column_name);
                        if (parentTable.primaryKeys.length > 1) {
                            childRowsQb.where((qb)=>{
                                for (const childId of childIds){
                                    qb.orWhere((0, _dbHelpers._wherePk)(parentTable.primaryKeys, childId));
                                }
                            });
                        } else if (typeof childIds[0] === 'object') {
                            childRowsQb.whereIn(`${parentTn}.${parentTable.primaryKey.column_name}`, childIds.map((c)=>(0, _dbHelpers.dataWrapper)(c).getByColumnNameTitleOrId(parentTable.primaryKey)));
                        } else {
                            childRowsQb.whereIn(`${parentTn}.${parentTable.primaryKey.column_name}`, childIds);
                        }
                        if (parentTable.primaryKey.column_name !== parentColumn.column_name) childRowsQb.select(`${parentTn}.${parentTable.primaryKey.column_name}`);
                        const childRows = await refBaseModel.execAndParse(childRowsQb, null, {
                            raw: true
                        });
                        if (childRows.length !== childIds.length) {
                            const missingIds = childIds.filter((id)=>!childRows.find((r)=>r[parentColumn.column_name] === (typeof id === 'object' ? (0, _dbHelpers.dataWrapper)(id).getByColumnNameTitleOrId(parentTable.primaryKey) : id)));
                            _catchError.NcError.get(baseModel.context).recordNotFound((0, _dbHelpers.extractIds)(missingIds));
                        }
                    }
                    const vTn = assocBaseModel.getTnPath(vTable);
                    const delQb = baseModel.dbDriver(vTn).where({
                        [vChildCol.column_name]: baseModel.dbDriver(childTn).select(childColumn.column_name).where((0, _dbHelpers._wherePk)(childTable.primaryKeys, rowId)).first()
                    }).delete();
                    delQb.whereIn(`${vTable.table_name}.${vParentCol.column_name}`, typeof childIds[0] === 'object' ? childIds.map((c)=>(0, _dbHelpers.dataWrapper)(c).getByColumnNameTitleOrId(parentTable.primaryKey)) : childIds);
                    await refBaseModel.execAndParse(delQb, null, {
                        raw: true
                    });
                    await parentBaseModel.updateLastModified({
                        model: parentTable,
                        rowIds: childIds,
                        cookie,
                        updatedColIds: [
                            (_this = await extractCorrespondingLinkColumn(baseModel.context, {
                                ltarColumn: column,
                                referencedTable: childTable,
                                referencedTableColumns: childTable.columns
                            })) == null ? void 0 : _this.id
                        ]
                    });
                    baseModel.dbDriver.attachToTransaction(async ()=>{
                        await parentBaseModel.getNonTransactionalClone().broadcastLinkUpdates(childIds);
                    });
                    await childBaseModel.updateLastModified({
                        model: childTable,
                        rowIds: [
                            rowId
                        ],
                        cookie,
                        updatedColIds: [
                            column.id
                        ]
                    });
                    baseModel.dbDriver.attachToTransaction(async ()=>{
                        await childBaseModel.getNonTransactionalClone().broadcastLinkUpdates([
                            rowId
                        ]);
                    });
                    auditConfig.parentModel = baseModel.model.id === parentTable.id ? parentTable : childTable;
                    auditConfig.childModel = baseModel.model.id === parentTable.id ? childTable : parentTable;
                }
                break;
            case _nocodbsdk.RelationTypes.HAS_MANY:
                {
                    validateRefIds(childIds, childTable);
                    // validate Ids
                    {
                        const childRowsQb = baseModel.dbDriver(childTn).select(childTable.primaryKey.column_name);
                        if (parentTable.primaryKeys.length > 1) {
                            childRowsQb.where((qb)=>{
                                for (const childId of childIds){
                                    qb.orWhere((0, _dbHelpers._wherePk)(parentTable.primaryKeys, childId));
                                }
                            });
                        } else if (typeof childIds[0] === 'object') {
                            childRowsQb.whereIn(parentTable.primaryKey.column_name, childIds.map((c)=>(0, _dbHelpers.dataWrapper)(c).getByColumnNameTitleOrId(parentTable.primaryKey)));
                        } else {
                            childRowsQb.whereIn(parentTable.primaryKey.column_name, childIds);
                        }
                        const childRows = await childBaseModel.execAndParse(childRowsQb, null, {
                            raw: true
                        });
                        if (childRows.length !== childIds.length) {
                            const missingIds = childIds.filter((id)=>!childRows.find((r)=>r[parentColumn.column_name] === (typeof id === 'object' ? (0, _dbHelpers.dataWrapper)(id).getByColumnNameTitleOrId(parentTable.primaryKey) : id)));
                            _catchError.NcError.get(baseModel.context).recordNotFound((0, _dbHelpers.extractIds)(missingIds));
                        }
                    }
                    const childRowsQb = baseModel.dbDriver(childTn);
                    if (parentTable.primaryKeys.length > 1) {
                        childRowsQb.where((qb)=>{
                            for (const childId of childIds){
                                qb.orWhere((0, _dbHelpers._wherePk)(parentTable.primaryKeys, childId));
                            }
                        });
                    } else {
                        childRowsQb.whereIn(parentTable.primaryKey.column_name, typeof childIds[0] === 'object' ? childIds.map((c)=>(0, _dbHelpers.dataWrapper)(c).getByColumnNameTitleOrId(parentTable.primaryKey)) : childIds);
                    }
                    await childBaseModel.execAndParse(childRowsQb.update({
                        [childColumn.column_name]: null
                    }), null, {
                        raw: true
                    });
                    await parentBaseModel.updateLastModified({
                        model: parentTable,
                        rowIds: [
                            rowId
                        ],
                        cookie,
                        updatedColIds: [
                            column.id
                        ]
                    });
                    baseModel.dbDriver.attachToTransaction(async ()=>{
                        await parentBaseModel.getNonTransactionalClone().broadcastLinkUpdates([
                            rowId
                        ]);
                    });
                }
                break;
            case _nocodbsdk.RelationTypes.BELONGS_TO:
                {
                    var _this1;
                    validateRefIds(childIds, parentTable);
                    auditConfig.parentModel = childTable;
                    auditConfig.childModel = parentTable;
                    const refBaseModel = parentBaseModel;
                    // validate Ids
                    {
                        if (childIds.length > 1) _catchError.NcError.get(baseModel.context).unprocessableEntity('Request must contain only one parent id');
                        const childRowsQb = baseModel.dbDriver(parentTn).select(parentTable.primaryKey.column_name).where((0, _dbHelpers._wherePk)(parentTable.primaryKeys, childIds[0])).first();
                        const childRow = await refBaseModel.execAndParse(childRowsQb, null, {
                            first: true,
                            raw: true
                        });
                        if (!childRow) {
                            _catchError.NcError.get(baseModel.context).recordNotFound((0, _dbHelpers.extractIds)(childIds, true));
                        }
                    }
                    await refBaseModel.execAndParse(baseModel.dbDriver(childTn)// .where({
                    //   [childColumn.cn]: baseModel.dbDriver(parentTable.tn)
                    //     .select(parentColumn.cn)
                    //     .where(parentTable.primaryKey.cn, childId)
                    //     .first()
                    // })
                    // .where(_wherePk(childTable.primaryKeys, rowId))
                    .where(childTable.primaryKey.column_name, rowId).update({
                        [childColumn.column_name]: null
                    }), null, {
                        raw: true
                    });
                    await parentBaseModel.updateLastModified({
                        model: parentTable,
                        rowIds: [
                            childIds[0]
                        ],
                        cookie,
                        updatedColIds: [
                            (_this1 = await extractCorrespondingLinkColumn(baseModel.context, {
                                ltarColumn: column,
                                referencedTable: childTable
                            })) == null ? void 0 : _this1.id
                        ]
                    });
                    baseModel.dbDriver.attachToTransaction(async ()=>{
                        await parentBaseModel.getNonTransactionalClone().broadcastLinkUpdates([
                            childIds[0]
                        ]);
                    });
                }
                break;
        }
        const parentAuditObj = [];
        const childAuditObj = [];
        for (const childId of childIds){
            const _childId = typeof childId === 'object' ? childBaseModel.extractPksValues(childId, true) : childId;
            parentAuditObj.push({
                rowId,
                refRowId: _childId,
                displayValue: (0, _dbHelpers.dataWrapper)(row).getByColumnNameTitleOrId(column),
                type: colOptions.type
            });
            if (parentTable.id !== childTable.id) {
                childAuditObj.push({
                    rowId: _childId,
                    refRowId: rowId,
                    refDisplayValue: (0, _dbHelpers.dataWrapper)(row).getByColumnNameTitleOrId(childColumn),
                    type: (0, _dbHelpers.getOppositeRelationType)(colOptions.type)
                });
            }
        }
        baseModel.dbDriver.attachToTransaction(async ()=>{
            await parentBaseModel.getNonTransactionalClone().afterAddOrRemoveChild({
                opType: _nocodbsdk.AuditV1OperationTypes.DATA_UNLINK,
                model: auditConfig.parentModel,
                refModel: auditConfig.childModel,
                columnTitle: auditConfig.parentColTitle,
                columnId: auditConfig.parentColId,
                refColumnTitle: auditConfig.childColTitle,
                refColumnId: auditConfig.childColId,
                req: cookie
            }, parentAuditObj);
            await childBaseModel.getNonTransactionalClone().afterAddOrRemoveChild({
                opType: _nocodbsdk.AuditV1OperationTypes.DATA_UNLINK,
                model: auditConfig.childModel,
                refModel: auditConfig.parentModel,
                columnTitle: auditConfig.childColTitle,
                columnId: auditConfig.childColId,
                refColumnTitle: auditConfig.parentColTitle,
                refColumnId: auditConfig.parentColId,
                req: cookie
            }, childAuditObj);
        });
    };
    return {
        addLinks,
        removeLinks,
        extractCorrespondingLinkColumn
    };
};
